module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.epgChannel),
      expression: "epgChannel"
    }],
    attrs: {
      "id": "epg"
    }
  }, [(_vm.epgLoading) ? _c('div', [_c('h4', {
    staticClass: "programs_empty-text"
  }, [_vm._v("Загрузка...")])]) : _c('div', [_c('div', {
    staticClass: "epg-fixed"
  }, [_c('div', {
    staticClass: "epg_controls"
  }, [_c('div', {
    staticClass: "epg_controls_button prev-button",
    on: {
      "click": _vm.epgPrevDay
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "epg_controls_button next-button",
    on: {
      "click": _vm.epgNextDay
    }
  }, [_c('i', {
    staticClass: "icon-arrow-right"
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "day-title"
  }, [_vm._v(_vm._s((_vm.epgChannel) ? _vm.epgChannel.name : '') + " "), _c('br'), _vm._v(" " + _vm._s(_vm.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "epg_programs"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.epgList.length === 0),
      expression: "epgList.length === 0"
    }],
    staticClass: "programs_empty-text"
  }, [_vm._v("Программа передач отсутствует")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.epgList.length !== 0),
      expression: "epgList.length !== 0"
    }]
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.epgList), function(program, index) {
    return _c('tr', {
      key: index,
      staticClass: "program-item"
    }, [_c('td', {
      staticStyle: {
        "color": "#999"
      }
    }, [(program.ut_start <= _vm.nowUTC) ? _c('div', [(_vm.archiveProgramInfo.utStart == program.ut_start && _vm.archiveProgramInfo.channelId == _vm.epgChannel.id) ? _c('div', [_c('div', {
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        "title": _vm.$parent.$parent.mode === 'teleteka' ? 'Играет сейчас (телетека)' : 'Играет сейчас (архив)'
      }
    }, [_c('i', {
      staticClass: "icon-control-play-filled"
    })])]) : _c('div', [(program.ut_end < _vm.nowUTC && program.ut_start < _vm.nowUTC) ? _c('div', [(_vm.$parent.teletekaEnabled && program.teleteka) ? _c('div', {
      staticStyle: {
        "font-size": "20px",
        "color": "#2196F3"
      },
      attrs: {
        "title": "Есть телетека"
      }
    }, [_vm._v("\n                                        T\n                                    ")]) : _c('div', {
      staticStyle: {
        "font-size": "20px",
        "color": "red"
      },
      attrs: {
        "title": "Есть архив"
      }
    }, [_vm._v("\n                                        R\n                                    ")])]) : _c('div', {
      staticStyle: {
        "font-size": "20px",
        "color": "greenyellow"
      },
      attrs: {
        "title": "Играет сейчас (live)"
      }
    }, [_vm._v("\n                                    L\n                                ")])])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v(_vm._s(_vm._f("time")(program.ut_start)))]), _vm._v(" "), _c('td', [(program.ut_end < _vm.nowUTC && program.ut_start < _vm.nowUTC) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openProgram(program, index)
        }
      }
    }, [_vm._v(_vm._s(program.progname))]) : _c('span', [_vm._v(_vm._s(program.progname))])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Архив")]), _vm._v(" "), _c('th', [_vm._v("Время")]), _vm._v(" "), _c('th', [_vm._v("Название")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-532ca5b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epg.vue
// module id = 94
// module chunks = 0